import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { MaterialImports } from '@environments/environment';
import { CustomFormsModule } from '@app/modules/forms.module';
import { FormsModule } from '@angular/forms';
import { BetStopReasonComponent } from '@components/betStopReason/betStopReason.component';

@NgModule({
  declarations: [BetStopReasonComponent],
  exports: [BetStopReasonComponent],
  imports: [CommonModule, SharedModule, UtilsModule, MaterialImports, RouterModule, CustomFormsModule, FormsModule],
})
export class BetStopReasonModule {}
